import { Drawer } from "@vesatogo/grass-core"
import { useSearchParams } from "react-router-dom"
import { PattiTimeline } from "../PattiTimeline"

const ProductionTimeline = ({ isProductionTrade = false }) => {
  const [params, setParams] = useSearchParams()
  const tradeId = parseInt(params.get("timeline") || "")

  return (
    <Drawer
      isOpen={tradeId ? true : false}
      title={
        <div className="flex flex-col">
          <span className="flex items-center text-lg text-gray-700 font-600">
            Trade Flow{" "}
            <span className="text-gray-500 text-sm font-400 ml-2">
              (Patti Journey Timeline)
            </span>
          </span>
        </div>
      }
      onClose={() => {
        params.delete("timeline")
        setParams(params)
      }}
      contentClassName="flex flex-col bg-gray-50"
    >
      <PattiTimeline tradeId={tradeId} isProductionTrade={isProductionTrade} />
    </Drawer>
  )
}

export default ProductionTimeline
